export const Entities = {
    first_name: { value: 'first_name', text: 'first name' },
    profile_link: { value: 'profile_link', text: 'profile link' }
};
export const AUDIO_TYPES = ['audio/mpeg', 'audio/webm', 'audio/mp3'];
export const VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
export const IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp'
];
export const MISC_TYPES = [
    'application/pdf',
    'image/heic',
    'application/zip',
    'application/zip',
    'application/zip-compressed',
    'application/x-zip-compressed',
    'multipart/x-zip'
];
export const SUPPORTED_FILE_TYPES = [
    ...AUDIO_TYPES,
    ...VIDEO_TYPES,
    ...IMAGE_TYPES,
    ...MISC_TYPES
];
export const TYPES_WITH_PREVIEW = [
    'audio/mpeg',
    'audio/webm',
    'audio/mp3',
    'video/mp4',
    'video/webm',
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp',
    'application/pdf'
];
//# sourceMappingURL=messages.js.map